const SCROLL_THRESHOLD_PX = 30;

function initializeStickyHeader() {
  const header = document.querySelector('.header');
  const body = document.body;
  if (!header) return;

  function updateScrolled() {
    if (window.scrollY > SCROLL_THRESHOLD_PX) {
      header.classList.add('header--scrolled');
      body.classList.add('mm-scrolling');
    } else {
      header.classList.remove('header--scrolled');
      body.classList.remove('mm-scrolling');
    }
  }

  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateScrolled();
        ticking = false;
      });
      ticking = true;
    }
  }

  updateScrolled(); // stan początkowy
  window.addEventListener('scroll', onScroll, { passive: true });
}

export default initializeStickyHeader;
